import { Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { FxFlexDirective, FxLayoutAlignDirective, FxLayoutDirective, FxLayoutGapDirective, ResponsiveService } from '@rspl-ui';
import { StarRatingModule } from 'angular-star-rating';

import { BaseSectionComponent } from '../base-section/base.component';

@Component({
  selector: 'rspl-extra-mile-split-landing',
  templateUrl: './extra-mile.component.html',
  styleUrl: './extra-mile.component.scss',
  imports: [FxLayoutDirective, FxLayoutAlignDirective, FxLayoutGapDirective, FxFlexDirective, StarRatingModule, MatIcon],
})
export class ExtraMileSectionComponent extends BaseSectionComponent {
  constructor(public override responsiveService: ResponsiveService) {
    super(responsiveService);
  }
}
